import { t } from "i18next";
import moment from "moment";
import React, { useState, useEffect, Fragment } from "react";
import { Accordion, Button, Col, Modal, ModalBody, Pagination, Row, Spinner, Table } from "react-bootstrap";
import apiService from "../services/api.service";
import CompanyGroupOrdersModal from "./CompanyGroupOrdersModal";



function CompanyOrders({ allOrders, addDays, getStatusNameById, getTotalRedeemedPerOrder, getRedeemHistory, loading, openHitoreyRow }) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [currentGroupOrders, setCurrentGroupOrders] = useState([])

    const getCurrentProduct = (orderId, products) => {
        if (products && products.length) {
            const product = products.find(pr => pr.orderId == orderId)
            return product
        }
    }

    const getCurrencyCode = (order) => {
        return order.products && order.products.length ?
            order.products[0].currencyCode.replace("ILS", "₪") : ''
    }

    const showOrdersModal = (groupId) => {
        setCurrentGroupOrders([])
        handleShow()
        apiService.getOrders({
            groupOrderId: groupId,
            groupOrders: 'false'
        }).then((response) => {
            setCurrentGroupOrders(response.data.data)
        })
    }

    return (
        <>
            {loading && !allOrders.length &&
                <td className="p-2">
                    <h6>Loading...</h6>
                </td>
            }
            {!!allOrders.length && allOrders.map((order, i) => {
                return !order.groupOrderId ?
                    <Fragment key={i}>
                        <tr className="order-item " onClick={e => openHitoreyRow("hist-row-" + order.orderId)} >
                            <td aria-label={t("orderNum") + order.orderId.toString().split('').join(' ')}>{order.orderId}</td>
                            <td aria-label={"שם השובר" + getCurrentProduct(order.orderId, order.products).productShortDescription ? getCurrentProduct(order.orderId, order.products).productShortDescription : getCurrentProduct(order.orderId, order.products).productName}> {getCurrentProduct(order.orderId, order.products).productShortDescription ? getCurrentProduct(order.orderId, order.products).productShortDescription : getCurrentProduct(order.orderId, order.products).productName}</td>
                            <td aria-label={t("VoucherNum") + order.voucherNumber.toString().split('').join(' ')}>{order.voucherNumber}</td>
                            <td aria-label={"תאריך הרכישה" + moment(order.orderPlacementDate).format('DD/MM/YYYY')}>{moment(order.orderPlacementDate).format('DD/MM/YYYY')} </td>
                            <td aria-label={"שווי השובר" + order.priceAfterCompanyDiscount + " " + order.products[0].currencyCode.replace("ILS", "₪")}>{order.priceAfterCompanyDiscount + " " + order.products[0].currencyCode.replace("ILS", "₪")}</td>
                            <td aria-label={"שם המקבל" + order.gifteeName ? order.gifteeName : order.customer.customerFirstName + " " + order.customer.customerLastName}>{order.gifteeName ? order.gifteeName : order.customer.customerFirstName + " " + order.customer.customerLastName} </td>
                            <td aria-label={"תוקף השובר" + getCurrentProduct(order.orderId, order.products).duration ? addDays(order.orderPlacementDate, getCurrentProduct(order.orderId, order.products).duration) : getCurrentProduct(order.orderId, order.products).productExpiryDate ? moment(getCurrentProduct(order.orderId, order.products).productExpiryDate).format('DD/MM/YYYY') : ""}> {
                                getCurrentProduct(order.orderId, order.products).duration || getCurrentProduct(order.orderId, order.products).productExpiryDate ?
                                    <Row>
                                        <Col className="expdate">
                                            <span> {getCurrentProduct(order.orderId, order.products).duration ? addDays(order.orderPlacementDate, getCurrentProduct(order.orderId, order.products).duration) : getCurrentProduct(order.orderId, order.products).productExpiryDate ? moment(getCurrentProduct(order.orderId, order.products).productExpiryDate).format('DD/MM/YYYY') : ""} </span>
                                        </Col>
                                    </Row> : null

                            } </td>
                            <td aria-label={"נותר למימוש" + getTotalRedeemedPerOrder(order.RedeemItem, getCurrentProduct(order.orderId, order.products).price, getCurrentProduct(order.orderId, order.products).currencyCode.replace("ILS", "₪"))}> <span className="clickable">{getTotalRedeemedPerOrder(order.RedeemItem, getCurrentProduct(order.orderId, order.products).price, getCurrentProduct(order.orderId, order.products).currencyCode.replace("ILS", "₪"))}</span></td>
                            <td aria-label={"סטטוס" + getStatusNameById(order.orderStatusId)}>{getStatusNameById(order.orderStatusId)} </td>
                        </tr>
                        <tr>
                            <td colSpan={9}>{getRedeemHistory(order.RedeemItem, getCurrentProduct(order.orderId, order.products).price, getCurrentProduct(order.orderId, order.products).currencyCode.replace("ILS", "₪"))}</td>
                        </tr>
                    </Fragment>
                    :
                    <Fragment key={i}>
                        <tr>
                            <td aria-label={t("orderNum") + order.groupOrderId}>{order.groupOrderId}</td>
                            <td aria-label={"שם השובר" + order.products && order.products.length ? order.products[0].productName : ''}> {order.products && order.products.length ? order.products[0].productName : ''}</td>
                            <td aria-label={t("VoucherNum") + order.voucherNumber.toString().split('').join(' ')}>{order.voucherNumber}</td>
                            <td aria-label={"תאריך הרכישה" + moment(order.orderPlacementDate).format('DD/MM/YYYY')}>{moment(order.orderPlacementDate).format('DD/MM/YYYY')} </td>
                            <td className="list-item" aria-label={"שווי השובר" + order.priceAfterCompanyDiscount ? order.priceAfterCompanyDiscount + " " + getCurrencyCode(order) : order.price + " " + getCurrencyCode(order)}>{order.priceAfterCompanyDiscount ? order.priceAfterCompanyDiscount + " " + getCurrencyCode(order) : order.price + " " + getCurrencyCode(order)}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <Button className="list-item" onClick={() => showOrdersModal(order.groupOrderId)}>{t("ShowOrderDetails")}</Button>
                            </td>
                        </tr>

                    </Fragment>
            })}
            {/* Group orders modal */}
            <Modal show={show} onHide={handleClose} size='xl' className="group-orders-modal">
                {currentGroupOrders && currentGroupOrders.length ?
                    <CompanyGroupOrdersModal
                        addDays={addDays}
                        getRedeemHistory={getRedeemHistory}
                        getStatusNameById={getStatusNameById}
                        getCurrentProduct={getCurrentProduct}
                        currentGroupOrders={currentGroupOrders}
                        getTotalRedeemedPerOrder={getTotalRedeemedPerOrder}
                    />
                    :
                    <Modal.Body className="justify-content-center d-flex p-5">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </Modal.Body>
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default CompanyOrders
